# https://github.com/OYsun/VueStar
# https://monterail.github.io/vuelidate/
# https://github.com/creotip/vue-particles

# Guides
# https://github.com/jamescryer/grumble.js
# https://github.com/tracelytics/pageguide
# https://github.com/heelhook/chardin.js

# Hotkeys
# mousetrap
# https://github.com/madrobby/keymaster

# Offline
# http://github.hubspot.com/offline/

# Exceptions and Vue errors
# https://sentry.io/for/vue/

# Infinite loading: https://peachscript.github.io/vue-infinite-loading/#!/installation

# Wizard:
# https://github.com/xaksis/vue-good-wizard

# Redis:
# https://redislabs.com/pricing/redis-cloud/

# Testing:
# E2E: http://nightwatchjs.org, http://webdriver.io/, https://devexpress.github.io/testcafe/, http://codecept.io/
# Unit: Tape, Jasmine,

# require './../node_modules_custom/web-worker-proxies.js'

# Tour:
# http://github.hubspot.com/shepherd/docs/welcome/
# http://introjs.com/
# https://github.com/xbsoftware/enjoyhint/
# http://linkedin.github.io/hopscotch/
#
# Bees:
# http://www.canstockphoto.com/search.php?search_type=ALL&search_phrase=bee&search_artist=HitToon
# http://www.gettyimages.ca/search/more-like-this/559914569?assettype=image&excludenudity=true&family=creative&license=rf&sort=best#license
# https://www.dreamstime.com/stock-illustration-cute-bee-emoji-set-mascot-different-face-expressions-image86081693
# https://www.etsy.com/listing/243489962/busy-bee-clip-art-and-digital-paper-set
# https://www.istockphoto.com/ca/vector/bee-expression-set-gm162404356-23168705
# https://pixabay.com/en/photos/?min_height=&image_type=vector&min_width=&q=bee&cat=

# Competitors:
# https://www.buxfer.com
# https://calendarbudget.com/home/testimonials
# https://www.pocketsmith.com/
# https://www.myvalue.com/controllers/newboard/
# https://www.moneydashboard.com/
# https://moneystrands.com/
# https://www.mvelopes.com
# https://getpocketbook.com/
# https://toshl.com
# https://www.powerwallet.com/

# Design
# https://www.designcrowd.ca
# https://www.fiverr.com/categories/graphics-design/web-plus-mobile-design/graphic-ui?source=category_filters&ref=main_type%3Awebsites%7Cseller_level%3Alevel_two_seller%2Ctop_rated_seller&filter=rating

# Offline:
# https://www.talater.com/upup/

# Hotkeys:
# https://github.com/Dafrok/v-hotkey

Vue.component('v-icon', require('vue-awesome/components/Icon').default)
Vue.component('help_tooltip', require('components/inside/elements/help_tooltip.vue').default)
Vue.component('help_modal', require('components/inside/elements/help_modal.vue').default)

Vue.use(VueRouter)
Vue.use require('vue-meta')

if HM.locale == 'en'
  locale = require('element-ui/lib/locale/lang/en').default
else
  locale = require('element-ui/lib/locale/lang/ru-RU').default
ElementLocale = require('element-ui/lib/locale')
ElementLocale.use locale

Vue.use require('element-ui/lib/date-picker').default
Vue.use require('element-ui/lib/option-group').default
Vue.use require('element-ui/lib/select').default
Vue.use require('element-ui/lib/form').default
Vue.use require('element-ui/lib/form-item').default
Vue.use require('element-ui/lib/option').default
Vue.use require('element-ui/lib/input').default
Vue.use require('element-ui/lib/steps').default
Vue.use require('element-ui/lib/step').default
Vue.use require('element-ui/lib/col').default

Loading = require('element-ui/lib/loading').default
Vue.prototype.$loading = Loading.service
Vue.use(Loading.directive)
Vue.prototype.$message = require('element-ui/lib/message').default
Vue.prototype.$notify = require('element-ui/lib/notification').default

MessageBox = require('element-ui/lib/message-box').default
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;

Vue.config.performance = process.env.NODE_ENV != 'production'
Vue.config.devtools = process.env.NODE_ENV != 'production'
Vue.config.productionTip = process.env.NODE_ENV == 'production'

if HM.is_development
  Vue.config.devtools = true
  Vue.config.performance = true

################ Detect browser ################
browser_name = ''
isIE = `/*@cc_on!@*/false || !!document.documentMode`
isEdge = !isIE && !!window.StyleMedia
if navigator.userAgent.indexOf("Chrome") != -1 && !isEdge
  browser_name = 'chrome'
else if navigator.userAgent.indexOf("Safari") != -1 && !isEdge
  browser_name = 'safari'
else if navigator.userAgent.indexOf("Firefox") != -1
  browser_name = 'firefox'
else if (navigator.userAgent.indexOf("MSIE") != -1 ) || (!!document.documentMode == true ) # IF IE > 10
  browser_name = 'ie'
else if isEdge
  browser_name = 'edge'
else
  browser_name = 'other-browser'
$('html').addClass(browser_name)
################################################

Vue.directive 'moveToBody',
  inserted: (el, binding) ->
    document.getElementsByTagName('body')[0].appendChild(el)
